// src/api/clients.js
import { BASE_API } from "../utils/constants";

/** Helpers **/
const authHeader = (token) => ({
  Authorization: `Bearer ${token}`,
});

const jsonHeaders = (token) => ({
  ...authHeader(token),
  "Content-Type": "application/json",
});

/* =======================
   CLIENTS
   ======================= */

export async function getClientsApi(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `${BASE_API}/api/finance/clients/${query ? `?${query}` : ""}`;

  const res = await fetch(url, { headers: authHeader(token) });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

export async function getClientByIdApi(id, token) {
  const url = `${BASE_API}/api/finance/clients/${id}/`;
  const res = await fetch(url, { headers: authHeader(token) });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

export async function createClientApi(payload, token) {
  const url = `${BASE_API}/api/finance/clients/`;
  const res = await fetch(url, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

export async function updateClientApi(id, payload, token) {
  const url = `${BASE_API}/api/finance/clients/${id}/`;
  const res = await fetch(url, {
    method: "PATCH",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

export async function deleteClientApi(id, token) {
  const url = `${BASE_API}/api/finance/clients/${id}/`;
  const res = await fetch(url, { method: "DELETE", headers: authHeader(token) });
  if (!res.ok) throw new Error("No se pudo eliminar el cliente");
  return true;
}
